<template>
  <div class="home-container">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="text-center mb-5">
            <img src="../../public/img/logosidebar.png" class="img-fluid logo-img" alt="Latydo Logo" />
          </div>
          <div class="d-grid gap-5 p-4">
            <router-link to="/soporte" 
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-headset"></i>
              Centro de Soporte
            </router-link>

            <router-link to="/borrar-cuenta" 
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-person-x"></i>
              Borrar mi cuenta
            </router-link>

            <a href="https://latydo.com" 
               target="_blank"
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-globe"></i>
              Visitar Latydo.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  background-color: #20C29D;
  display: flex;
  align-items: center;
}

.logo-img {
  max-width: 200px;
  margin: 0 auto;
}

.custom-btn {
  transition: all 0.3s ease;
  border-radius: 12px;
  font-weight: 600;
  padding: 25px 30px;
  background-color: transparent;
  border: 2px solid white;
  color: white;
  font-size: 1.1rem;
  text-decoration: none;
  margin-bottom: 10px;
}

.custom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.bi {
  font-size: 1.4rem;
}
</style>
